module.exports = __webpack_public_path__ + "static/media/sort.383bcd5e.jpg";